module.exports = __webpack_public_path__ + "img/4.0df099d8.jpg";